import { render, staticRenderFns } from "./rewards.vue?vue&type=template&id=c624838c&scoped=true"
import script from "./rewards.vue?vue&type=script&lang=js"
export * from "./rewards.vue?vue&type=script&lang=js"
import style0 from "./rewards.vue?vue&type=style&index=0&id=c624838c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c624838c",
  null
  
)

export default component.exports